import { useState } from "react";
import { CalendarPlus, Download, ChevronDown } from "lucide-react";
import { API } from "@/lib/api";

const pad = (n) => String(n).padStart(2, "0");
const stamp = (d) =>
  `${d.getUTCFullYear()}${pad(d.getUTCMonth() + 1)}${pad(d.getUTCDate())}T${pad(d.getUTCHours())}${pad(
    d.getUTCMinutes()
  )}00Z`;

export const CalendarExport = ({ event }) => {
  const [open, setOpen] = useState(false);
  const start = new Date(event.start_at);
  const end = new Date(event.end_at || event.start_at);
  const loc = event.address || event.venue_name;
  const details = event.summary || "";

  const google = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(
    event.title
  )}&dates=${stamp(start)}/${stamp(end)}&details=${encodeURIComponent(details)}&location=${encodeURIComponent(loc)}`;

  const outlook = `https://outlook.live.com/calendar/0/deeplink/compose?path=/calendar/action/compose&rru=addevent&subject=${encodeURIComponent(
    event.title
  )}&startdt=${start.toISOString()}&enddt=${end.toISOString()}&body=${encodeURIComponent(
    details
  )}&location=${encodeURIComponent(loc)}`;

  const ics = `${API}/events/${event.event_id}/ics`;

  const item =
    "flex items-center gap-2 px-4 py-2.5 text-sm font-medium text-neutral-800 transition-colors duration-200 hover:bg-neutral-100";

  return (
    <div className="relative">
      <button
        data-testid="calendar-export-trigger"
        onClick={() => setOpen((o) => !o)}
        className="flex w-full items-center justify-center gap-2 rounded-full border border-neutral-900 py-3 text-sm font-bold text-neutral-900 transition-colors duration-200 hover:bg-neutral-100"
      >
        <CalendarPlus className="h-4 w-4" /> Add to calendar
        <ChevronDown className={`h-4 w-4 transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
      </button>

      {open && (
        <div
          data-testid="calendar-export-menu"
          className="absolute left-0 right-0 z-20 mt-2 overflow-hidden rounded-xl border border-neutral-200 bg-white py-1 shadow-[0_8px_28px_rgba(0,0,0,0.18)]"
        >
          <a href={google} target="_blank" rel="noreferrer" className={item} data-testid="export-google">
            Google Calendar
          </a>
          <a href={outlook} target="_blank" rel="noreferrer" className={item} data-testid="export-outlook">
            Outlook Calendar
          </a>
          <a href={ics} className={item} data-testid="export-apple">
            Apple Calendar (.ics)
          </a>
          <a href={ics} download className={item} data-testid="export-ics">
            <Download className="h-4 w-4" /> Download .ics file
          </a>
        </div>
      )}
    </div>
  );
};
